// extracted by mini-css-extract-plugin
export default {"input":"Input_input__n58Nm","default":"Input_default__Pju3K","small":"Input_small__7k8cF"};